/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * NoorWriter API
 * API for NoorWriter Chrome extension - AI writing assistant
 *
 * The version of the OpenAPI document: v1
 * Contact: contact@noorways.fr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios from 'axios'
import type { AxiosPromise, AxiosInstance } from 'axios'
import type { Configuration } from '../configuration'
import type { RequestConfig } from '../base'
// Some imports not used depending on template conditions
// @ts-ignore
import * as Common from '../common'
const {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} = Common
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from '../base'
import type { RequestArgs } from '../base'
// @ts-ignore
import type { PricingInfo } from '../models'
// @ts-ignore
import type { PricingResponse } from '../models'
// @ts-ignore
import type { ProblemDetails } from '../models'
/**
 * PricingApi - axios parameter creator
 * @export
 */
export const PricingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Clears the pricing cache to force refresh from Stripe (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clearCache: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/pricing/clear-cache`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sample request:                  GET /api/pricing/monthly
     * @summary Gets pricing information for a specific plan
     * @param {string} planId The plan identifier (monthly or yearly)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlanPricing: async (planId: string, options: RequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('getPlanPricing', 'planId', planId)
      const localVarPath = `/api/pricing/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sample request:                  GET /api/pricing              Sample response:                  {       \"success\": true,       \"plans\": [         {           \"planId\": \"monthly\",           \"planName\": \"Premium Monthly\",           \"priceAmount\": 999,           \"price\": 9.99,           \"currency\": \"EUR\",           \"interval\": \"month\",           \"stripePriceId\": \"price_1234567890\",           \"isRecommended\": false         },         {           \"planId\": \"yearly\",           \"planName\": \"Premium Yearly\",           \"priceAmount\": 8999,           \"price\": 89.99,           \"currency\": \"EUR\",           \"interval\": \"year\",           \"stripePriceId\": \"price_0987654321\",           \"isRecommended\": true,           \"savings\": \"Save 25%\"         }       ],       \"lastUpdated\": \"2025-01-05T10:30:00Z\",       \"cacheExpirationSeconds\": 3600     }
     * @summary Gets current pricing information for all subscription plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricing: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/pricing`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PricingApi - functional programming interface
 * @export
 */
export const PricingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PricingApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Clears the pricing cache to force refresh from Stripe (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clearCache(
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clearCache(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Sample request:                  GET /api/pricing/monthly
     * @summary Gets pricing information for a specific plan
     * @param {string} planId The plan identifier (monthly or yearly)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPlanPricing(
      planId: string,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PricingInfo>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanPricing(planId, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Sample request:                  GET /api/pricing              Sample response:                  {       \"success\": true,       \"plans\": [         {           \"planId\": \"monthly\",           \"planName\": \"Premium Monthly\",           \"priceAmount\": 999,           \"price\": 9.99,           \"currency\": \"EUR\",           \"interval\": \"month\",           \"stripePriceId\": \"price_1234567890\",           \"isRecommended\": false         },         {           \"planId\": \"yearly\",           \"planName\": \"Premium Yearly\",           \"priceAmount\": 8999,           \"price\": 89.99,           \"currency\": \"EUR\",           \"interval\": \"year\",           \"stripePriceId\": \"price_0987654321\",           \"isRecommended\": true,           \"savings\": \"Save 25%\"         }       ],       \"lastUpdated\": \"2025-01-05T10:30:00Z\",       \"cacheExpirationSeconds\": 3600     }
     * @summary Gets current pricing information for all subscription plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPricing(
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PricingResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPricing(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
  }
}

/**
 * PricingApi - factory interface
 * @export
 */
export const PricingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PricingApiFp(configuration)
  return {
    /**
     *
     * @summary Clears the pricing cache to force refresh from Stripe (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clearCache(options?: any): AxiosPromise<void> {
      return localVarFp.clearCache(options).then((request) => request(axios, basePath))
    },
    /**
     * Sample request:                  GET /api/pricing/monthly
     * @summary Gets pricing information for a specific plan
     * @param {string} planId The plan identifier (monthly or yearly)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlanPricing(planId: string, options?: any): AxiosPromise<PricingInfo> {
      return localVarFp.getPlanPricing(planId, options).then((request) => request(axios, basePath))
    },
    /**
     * Sample request:                  GET /api/pricing              Sample response:                  {       \"success\": true,       \"plans\": [         {           \"planId\": \"monthly\",           \"planName\": \"Premium Monthly\",           \"priceAmount\": 999,           \"price\": 9.99,           \"currency\": \"EUR\",           \"interval\": \"month\",           \"stripePriceId\": \"price_1234567890\",           \"isRecommended\": false         },         {           \"planId\": \"yearly\",           \"planName\": \"Premium Yearly\",           \"priceAmount\": 8999,           \"price\": 89.99,           \"currency\": \"EUR\",           \"interval\": \"year\",           \"stripePriceId\": \"price_0987654321\",           \"isRecommended\": true,           \"savings\": \"Save 25%\"         }       ],       \"lastUpdated\": \"2025-01-05T10:30:00Z\",       \"cacheExpirationSeconds\": 3600     }
     * @summary Gets current pricing information for all subscription plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricing(options?: any): AxiosPromise<PricingResponse> {
      return localVarFp.getPricing(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * PricingApi - object-oriented interface
 * @export
 * @class PricingApi
 * @extends {BaseAPI}
 */
export class PricingApi extends BaseAPI {
  /**
   *
   * @summary Clears the pricing cache to force refresh from Stripe (admin only)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricingApi
   */
  public clearCache(options?: RequestConfig) {
    return PricingApiFp(this.configuration)
      .clearCache(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sample request:                  GET /api/pricing/monthly
   * @summary Gets pricing information for a specific plan
   * @param {string} planId The plan identifier (monthly or yearly)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricingApi
   */
  public getPlanPricing(planId: string, options?: RequestConfig) {
    return PricingApiFp(this.configuration)
      .getPlanPricing(planId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sample request:                  GET /api/pricing              Sample response:                  {       \"success\": true,       \"plans\": [         {           \"planId\": \"monthly\",           \"planName\": \"Premium Monthly\",           \"priceAmount\": 999,           \"price\": 9.99,           \"currency\": \"EUR\",           \"interval\": \"month\",           \"stripePriceId\": \"price_1234567890\",           \"isRecommended\": false         },         {           \"planId\": \"yearly\",           \"planName\": \"Premium Yearly\",           \"priceAmount\": 8999,           \"price\": 89.99,           \"currency\": \"EUR\",           \"interval\": \"year\",           \"stripePriceId\": \"price_0987654321\",           \"isRecommended\": true,           \"savings\": \"Save 25%\"         }       ],       \"lastUpdated\": \"2025-01-05T10:30:00Z\",       \"cacheExpirationSeconds\": 3600     }
   * @summary Gets current pricing information for all subscription plans
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricingApi
   */
  public getPricing(options?: RequestConfig) {
    return PricingApiFp(this.configuration)
      .getPricing(options)
      .then((request) => request(this.axios, this.basePath))
  }
}
